<template>
  <div class="header-container">
    <div class="school-logo">
      <!-- <div class="logo1 right-line"></div>
      <div class="logo2"></div> -->
      <div class="logo"></div>
    </div>
    <div class="school-name">
      <h1>高等教育自学考试助学培训报名系统</h1>
    </div>
    <div class="conect_tel">技术咨询电话：028-86586568</div>
    <div v-if="$route.path !== '/' && $route.path !== '/paySuccess' && !$route.meta.isApply" class="user-handle">
      当前用户: {{ userName }}
      <el-button class="exit" @click="quit">退出</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHead",
  data() {
    return {
      showUserName: false,
    };
  },
  computed: {
    userName() {
      return this.$store.state.userName;
    },
  },
  created() {},
  mounted() {},
  methods: {
    quit() {
      // 退出到登录页
      this.$store.commit("userExit");
    },
  },
};
</script>

<style scoped lang="less">
.header-container {
  display: flex;
  padding: 0 20px;
  margin-bottom: 6px;
  box-sizing: border-box;
  background-color: #0356a1;
  .school-logo {
    margin-left: 40px;
    display: flex;
    align-items: center;
    // flex-direction: column;
    justify-content: center;
     .logo{
      width: 457px;
      height: 68px;
      background: url('../assets/login/main_logo2.png') 50% no-repeat;
      background-size: cover;
      // -webkit-transform: scale(0.8);
      // transform: scale(0.8);
    }
    .right-line {
      position: relative;
    }
    .right-line:after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: inline-block;
    height: 80%;
    left: 280px;
    border-right: 2px solid #fff;
}
 .logo2{
    width: 145px;
    height: 59px;
    background: url('../assets/login/login_log.png') 50% no-repeat;
    background-size: cover;
    -webkit-transform: scale(.85);
    transform: scale(.85);
    margin-left: 15px;
}

  }
  .school-name {
    margin-left: 1vw;
    line-height: 100px;
    color: white;
    letter-spacing: 3px;
    h1{
      font-size: 24px;
    }
  }
  .conect_tel{
    font-size: 16px;
    line-height: 100px;
    color: white;
    margin: auto;
  }
  .user-handle {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: white;
    .exit {
      margin-left: 30px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .header-container {
    --scale_value: 0.7;
  }
  .logo {
    width: calc(457px * var(--scale_value)) !important;
    height: calc(68px * var(--scale_value)) !important;
  }
  .school-logo {
    // margin-left: 120px !important;
  }
  .school-name {
    margin-left: 3vw !important;
    h1{
      font-size: 20px !important;
    }
  }
  .conect_tel{
    font-size: 14px !important;
  }
  .user-handle {
    .exit {
      margin-left: 20px !important;
    }
  }
}
</style>
